<div class="bookingWaitingPage__cont animated {{animation}}">
  <div class="bookingWaitingPage__header">
    <app-ds-typography
      [size]="fontSize.RG"
      [color]="fontColor.Primary"
      [fontFamily]="fontFamily.SemiBold"
      [text]="'BOOKING_MODULE.WAITING_PAGE.TITLE' | transloco ">
    </app-ds-typography>
    <div class="loader">
      <app-btn-loader
        [btnSize]="btnSize"
        [classColor]="loaderColor">
      </app-btn-loader>
    </div>
  </div>
  <div class="bookingWaitingPage__body">
    <div class="bookingWaitingPage__section--productHeader" [class.show-alert]="showProviderAlert">
      <ng-container [ngSwitch]="type">
        <ng-container *ngSwitchCase="bookingType.FLIGHTS_BY_SECTOR">
          <ng-container *ngTemplateOutlet="flightProductItem"></ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="bookingType.FLIGHTS">
          <ng-container *ngTemplateOutlet="flightProductItem"></ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="bookingType.HOTELS">
          <ng-container *ngTemplateOutlet="hotelProductItem"></ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="bookingType.AUTOS">
          <ng-container *ngTemplateOutlet="autoProductItem"></ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="bookingType.PACKAGE_AIR">
          <ng-container *ngTemplateOutlet="airPackageProductItem"></ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="bookingType.BUSES">
          <ng-container *ngTemplateOutlet="busProductItem"></ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="bookingType.ACTIVITIES">
          <ng-container *ngTemplateOutlet="activitiesProductItem"></ng-container>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="orderWithAssistance">
        <ng-container *ngTemplateOutlet="assistanceProductItem"></ng-container>
      </ng-container>
      <ng-container *ngIf="showProviderAlert">
        <div class="bookingWaitingPage__section--productHeaderItem flex alert">
          <app-alert-message 
            [text]="providerAlertMessage | transloco"
            [alertType]="alertType">
          </app-alert-message>
        </div>
      </ng-container>
    </div>
    <app-waiting-product-info
      [props]="props"
      [type]="type"
      [isMobile]="isMobile"
      [airValidation]="airValidation"
      [airValidationBySector]="airValidationBySector"
      [hotelValidation]="hotelValidation"
      [autoValidation]="autoValidation"
      [activitiesValidation]="activitiesValidation"
      [isMultipleCarriers]="isMultipleCarriers"
      [capacity]="capacity"
    ></app-waiting-product-info>
  </div>
</div>

<ng-template #flightProductItem>
  <div class="bookingWaitingPage__section--productHeaderItem flex">
    <ng-container *ngIf="!isMultipleCarriers; else imageMultipleCarriersTemplate">
      <ng-container *ngTemplateOutlet="imageTemplate; context: { src: airlineOrCompany?.AirlineCode | airlineImage }"></ng-container>
    </ng-container>
    <div class="bookingWaitingPage__sectionCont">
      <div class="box">
        <div class="flex-center-box-cont">
          <app-ds-typography
            [size]="fontSize.XXS"
            [color]="fontColor.Primary"
            [fontFamily]="fontFamily.Regular"
            [text]="departure">
          </app-ds-typography>
          <ng-container *ngTemplateOutlet="iconTemplate; context: { icon: arrowIcon }"></ng-container>
          <app-ds-typography
            [size]="fontSize.XXS"
            [color]="fontColor.Primary"
            [fontFamily]="fontFamily.Regular"
            [text]="arrivalOrDestination">
          </app-ds-typography>
        </div>
      </div>
      <div class="box">
        <app-ds-typography
          [size]="fontSize.XXS"
          [color]="fontColor.Secondary"
          [fontFamily]="fontFamily.Regular"
          [text]="(isMultipleCarriers) ? ('BOOKING_MODULE.WAITING_PAGE.MULTIPLE_CARRIERS' | transloco) : (airlineOrCompany?.AirlineName | airlineName )">
        </app-ds-typography>
      </div>
    </div>
  </div>
  <ng-template #imageMultipleCarriersTemplate>
    <div class="icon-context">
      <ng-container *ngTemplateOutlet="iconTemplate; context: { icon: icon.MultipleFlights }"></ng-container>
    </div>
  </ng-template>
</ng-template>

<ng-template #hotelProductItem let-extraClass="extraClass">
  <div class="bookingWaitingPage__section--productHeaderItem {{extraClass}}">
    <ng-container *ngTemplateOutlet="iconTemplate; context: { icon: icon.Hotels }"></ng-container>
    <div class="bookingWaitingPage__sectionCont flex-start">
      <div class="box">
        <app-ds-typography
          [size]="fontSize.XXS"
          [color]="fontColor.Primary"
          [fontFamily]="fontFamily.Regular"
          [text]="hotelName | capitalizeAll">
        </app-ds-typography>
        <app-ds-typography
          [size]="fontSize.XXS"
          [color]="fontColor.Secondary"
          [fontFamily]="fontFamily.Regular"
          [text]="arrivalOrDestination | placeName | async">
        </app-ds-typography>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #autoProductItem>
  <div class="bookingWaitingPage__section--productHeaderItem">
    <ng-container *ngTemplateOutlet="imageTemplate; context: { src: autoCompanyImage }"></ng-container>
    <div class="bookingWaitingPage__sectionCont flex-start">
      <div class="box">
        <app-ds-typography
          [size]="fontSize.XXS"
          [color]="fontColor.Primary"
          [fontFamily]="fontFamily.Regular"
          [text]="autoModel | capitalizeAll">
        </app-ds-typography>
        <app-ds-typography
          [size]="fontSize.XXS"
          [color]="fontColor.Secondary"
          [fontFamily]="fontFamily.Regular"
          [text]="arrivalOrDestination | placeName | async">
        </app-ds-typography>
      </div>
      <div class="box">
        <app-ds-typography
          [size]="fontSize.XXS"
          [color]="fontColor.Secondary"
          [fontFamily]="fontFamily.Regular"
          [text]="autoCompany | capitalizeAll">
        </app-ds-typography>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #airPackageProductItem>
  <ng-container *ngTemplateOutlet="flightProductItem"></ng-container>
  <ng-container *ngTemplateOutlet="hotelProductItem; context: { extraClass: 'top' }"></ng-container>
</ng-template>

<ng-template #busProductItem>
  <div class="bookingWaitingPage__section--productHeaderItem flex">
    <ng-container *ngTemplateOutlet="imageTemplate; context: { src: airlineOrCompany?.AirlineCode | busCompanyImage }"></ng-container>
    <div class="bookingWaitingPage__sectionCont">
      <div class="box">
        <div class="flex-center-box-cont">
          <app-ds-typography
            [size]="fontSize.XXS"
            [color]="fontColor.Primary"
            [fontFamily]="fontFamily.Regular"
            [text]="airlineOrCompany?.AirlineCode | busCompanyName | async">
          </app-ds-typography>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #activitiesProductItem>
  <div class="bookingWaitingPage__section--productHeaderItem flex">
    <ng-container *ngTemplateOutlet="iconTemplate; context: { icon: icon.CivitatisFlat }"></ng-container>
    <div class="bookingWaitingPage__sectionCont">
      <div class="box">
        <app-ds-typography
          [size]="fontSize.XXS"
          [color]="fontColor.Primary"
          [fontFamily]="fontFamily.Regular"
          [text]="activityTitle">
        </app-ds-typography>
        <app-ds-typography
          [size]="fontSize.XXS"
          [color]="fontColor.Secondary"
          [fontFamily]="fontFamily.Regular"
          [text]="activityName">
        </app-ds-typography>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #assistanceProductItem>
  <div class="bookingWaitingPage__section--productHeaderItem flex top">
    <div class="bg-image">
      <ng-container *ngTemplateOutlet="imageTemplate; context: { bgActive: true, src: CHUBB_LOGO | baseImage: CHUBB_BOOKING_IMAGES_BASE_PATH }"></ng-container>
    </div>
    <div class="bookingWaitingPage__sectionCont">
      <div class="box">
        <app-ds-typography
          [size]="fontSize.XXS"
          [color]="fontColor.Primary"
          [fontFamily]="fontFamily.Regular"
          [text]="'BOOKING_MODULE.WAITING_PAGE.ASSISTANCE_TITLE' | transloco">
        </app-ds-typography>
      </div>
      <div class="box">
        <app-ds-typography
          [size]="fontSize.XXS"
          [color]="fontColor.Secondary"
          [fontFamily]="fontFamily.Regular"
          [text]="'BOOKING_MODULE.WAITING_PAGE.ASSISTANCE_TYPE' | transloco">
        </app-ds-typography>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #iconTemplate let-icon="icon">
<app-ds-icon
  [icon]="icon"
  [size]="iconSize"
  [color]="iconColor.Primary">
</app-ds-icon>
</ng-template>

<ng-template #imageTemplate let-src="src" let-bgActive="bgActive">
  <img [class.bg]="bgActive" loading="lazy" [src]="src" alt="">
</ng-template>